import { Routes } from '@angular/router';

import { UserloginComponent } from '../../back-office/user-login/user-login.component';
import { SignUpComponent } from '../../back-office/sign-up/sign-up.component';
import { OTPVerificationComponent } from '../../back-office/otp-verification/otp-verification.component';
import { ForgotPasswordComponent } from '../../back-office/forgot-password/forgot-password.component';
import { ResendOtpComponent } from '../../back-office/resend-otp/resend-otp.component';
import { ResetPasswordComponent } from '../../back-office/reset-password/reset-password.component';
import { HomeComponent } from '../../back-office/home/home.component';

export const LoginLayoutRoutes: Routes = [
    { path: 'login', component: UserloginComponent },
    { path: 'signup', component: SignUpComponent },
    { path: 'otp-verification', component: OTPVerificationComponent },
    { path: 'reset-password-verify-otp', component: OTPVerificationComponent},
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'resend-otp/', component: ResendOtpComponent },
    { path: 'reset-password', component: ResetPasswordComponent },
    { path: 'home', component: HomeComponent },
];
